import { IntlShape } from "react-intl";
import { z } from "zod";

export const createCaseSchema = (intl: IntlShape) =>
  z.object({
    name: z
      .string()
      .min(1, intl.formatMessage({ id: "validation.nameRequired" })),
    dateOfBirth: z
      .date()
      .optional()
      .or(z.literal("").transform(() => undefined))
      .or(z.null().transform(() => undefined)),
    dateOfLoss: z
      .date()
      .optional()
      .or(z.literal("").transform(() => undefined))
      .or(z.null().transform(() => undefined)),
    claimNumber: z
      .string()
      .max(100, intl.formatMessage({ id: "validation.claimNumberMaxLength" }))
      .optional()
      .or(z.literal("").transform(() => undefined)),
  });
